<template>
  <span v-if="value === null" :class="$style.dash"> — </span>
  <span v-else :style="computedStyle" :class="[$style.badge, { [$style.fullWidth]: fullWidth }]">
    {{ value }}
  </span>
</template>

<script>
import { defineComponent } from 'vue';
import values from 'lodash/values';
import { EStyleType } from '../common/enums';
import { ColorMap } from '../common/style';

export default defineComponent({
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
    type: {
      type: [String, Number],
      default: null,
      validator: (value) => value === null || values(EStyleType).includes(value),
    },
  },
  computed: {
    computedStyle() {
      if (this.type === null) return undefined;
      return { '--badge-color': `var(${ColorMap[this.type]})` };
    },
  },
});
</script>

<style module lang="scss">
.badge {
  padding: 1px 9px;
  border-radius: 2px;
  --badge-color: var(--neutral-color);
  background-color: var(--badge-color);
  text-align: center;
  display: inline-block;

  font-style: normal;
  font-weight: 500;
  font-size: 12px;

  color: #ffffff;
  border: 1px solid transparent;

  @media print {
    background-color: transparent !important;
    border-color: #575757;
    color: #575757;
  }
}
.fullWidth {
  padding: 2px;
  width: 100%;
}

.dash {
  text-align: center;
  width: 100%;
  display: block;
}
</style>
